import { useHead } from "@unhead/react";
import type { ComponentProps } from "react";

const babelSharkConfig = `
window.babelSharkConfig = {
  projectId: 3810095,
  accessCode: "9ofAEqSltcL0R5PCwUA7a-WPFwAugSsBZ1rMdwFNE8PsPsGcT3"
};
`;

const BabelShark = () => {
	useHead({
		script: [
			{ textContent: babelSharkConfig },
			{
				defer: true,
				src: "https://cdn.babelshark.net/static/babelshark-embed/babelshark.js",
			},
		],
	});

	return <span className="bs-activator" data-drop="auto" />;
};

export const BabelSharkParagraph = ({
	className,
	...props
}: ComponentProps<"p">) => (
	<p
		className={["__", className].filter(Boolean).join(" ")}
		{...props}
	/>
);

export const BabelSharkListItem = ({
	className,
	...props
}: ComponentProps<"li">) => (
	<li
		className={["__", className].filter(Boolean).join(" ")}
		{...props}
	/>
);

export default BabelShark;
